var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPatientid({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_439_819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 15.8889C14.6873 15.8889 16.0551 14.5211 16.0551 12.8339C16.0551 11.1466 14.6873 9.77887 13.0001 9.77887C11.3128 9.77887 9.94507 11.1466 9.94507 12.8339C9.94507 14.5211 11.3128 15.8889 13.0001 15.8889Z",
    fill: "#5C5CAB",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1666 2.8889C15.1666 2.50581 15.0144 2.13841 14.7435 1.86753C14.4726 1.59664 14.1052 1.44446 13.7221 1.44446H12.2777C11.8946 1.44446 11.5272 1.59664 11.2563 1.86753C10.9854 2.13841 10.8333 2.50581 10.8333 2.8889V7.22224H15.1666V2.8889Z",
    fill: "#5C5CAB",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.40997 19.5C7.28719 19.6481 7.22069 19.8348 7.22219 20.0272V21.6667H18.7777V20.0055C18.7799 19.8131 18.7133 19.6261 18.59 19.4783C17.8891 18.6975 17.025 18.0805 16.0589 17.6711C15.0928 17.2617 14.0485 17.0699 13 17.1094C11.9498 17.0726 10.9044 17.2678 9.93823 17.681C8.97205 18.0942 8.10881 18.7152 7.40997 19.5Z",
    fill: "#5C5CAB",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2221 4.33331H16.611V5.77776H20.2221V23.1111H5.7777V5.77776H9.38881V4.33331H5.7777C5.39461 4.33331 5.02721 4.4855 4.75632 4.75638C4.48543 5.02727 4.33325 5.39467 4.33325 5.77776V23.1111C4.33325 23.4942 4.48543 23.8616 4.75632 24.1325C5.02721 24.4034 5.39461 24.5555 5.7777 24.5555H20.2221C20.6052 24.5555 20.9726 24.4034 21.2435 24.1325C21.5144 23.8616 21.6666 23.4942 21.6666 23.1111V5.77776C21.6666 5.39467 21.5144 5.02727 21.2435 4.75638C20.9726 4.4855 20.6052 4.33331 20.2221 4.33331Z",
    fill: "#5C5CAB",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_439_819"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientid);
export default __webpack_public_path__ + "static/media/patientid.bcaf7a853ab09b535330386e88db693f.svg";
export { ForwardRef as ReactComponent };